// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsible-wrap {
  width: 100%;
}
.collapsible-wrap .toggleBtn {
  width: 100%;
  min-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border: none;
  color: black;
  font-size: 16px;
  cursor: pointer;
  text-align: left;
  gap: 25px;
  padding: 0 50px;
}
.collapsible-wrap .content {
  width: auto;
  height: auto;
  display: none;
}
.collapsible-wrap .show-content {
  width: auto;
  height: auto;
  display: flex;
  transition: 0.3s ease-in-out;
}

.overlay {
  z-index: 98;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vw;
  background-color: rgba(0, 0, 0, 0.8);
  padding: 25px;
  display: flex;
  justify-content: center;
}
.overlay .overlay-content {
  max-width: 400px;
  width: 100%;
  min-height: 300px;
  max-height: 80vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
}
.overlay .overlay-content.informational {
  max-width: 600px;
  justify-content: initial;
  border-radius: 15px;
}
.overlay .overlay-content.informational .close-overlay {
  display: flex;
  width: inherit;
  justify-content: end;
}
.overlay .overlay-content.informational .close-overlay svg {
  font-size: 35px;
  color: red;
  cursor: pointer;
}
.overlay .overlay-content.informational .body-overlay {
  display: flex;
  width: 100%;
  padding: 25px;
  flex-direction: column;
  overflow-y: scroll;
  position: relative;
}
.overlay .overlay-content.informational .body-overlay .caregiver-photo-wrapper {
  display: flex;
  justify-content: center;
}
.overlay .overlay-content.informational .body-overlay .caregiver-photo-wrapper .caregiver-photo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin-top: -120px;
  border: 5px solid white;
}
.overlay .overlay-content.informational .body-overlay .caregiver-photo-wrapper .caregiver-photo img {
  width: 100%;
}
.overlay .overlay-content.informational .body-overlay ul {
  margin: 0;
  padding: 0 0 0 13px;
}
.overlay .overlay-content.informational .body-overlay h2 {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  border-bottom: 1px solid #f5eee7;
  padding-bottom: 15px;
  margin-bottom: 0;
}
.overlay .overlay-content.informational .body-overlay .row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  border-bottom: 1px solid #f5eee7;
}
.overlay .overlay-content.informational .body-overlay .row .col:first-child {
  flex: 0 0 40%;
  justify-content: left;
  border-right: 1px solid #f5eee7;
}
.overlay .overlay-content.informational .body-overlay .row .col {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
}
.overlay .overlay-content .buttons-wrapper {
  display: flex;
  gap: 5px;
}

@media (max-width: 768px) {
  .collapsible-wrap .toggleBtn {
    padding: 0 10px;
    font-size: 14px;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Collapsible/styles.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AADF;AAEE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AAAJ;AAEE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,4BAAA;AADJ;;AAKA;EACE,WAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;AAFF;AAGE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AADJ;AAEI;EACE,gBAAA;EACA,wBAAA;EACA,mBAAA;AAAN;AACM;EACE,aAAA;EACA,cAAA;EACA,oBAAA;AACR;AAAQ;EACE,eAAA;EACA,UAAA;EACA,eAAA;AAEV;AACM;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AACR;AAAQ;EACE,aAAA;EACA,uBAAA;AAEV;AADU;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAGZ;AAFY;EACE,WAAA;AAId;AACQ;EACE,SAAA;EACA,mBAAA;AACV;AACQ;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,gBAAA;AACV;AACQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;AACV;AAAU;EACE,aAAA;EACA,qBAAA;EACA,+BAAA;AAEZ;AAAU;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAEZ;AAGI;EACE,aAAA;EACA,QAAA;AADN;;AAMA;EAEI;IACE,eAAA;IACA,eAAA;IACA,gBAAA;EAJJ;AACF","sourcesContent":["@import \"../../css/colors.scss\";\n@import \"../../css/breakpoints.scss\";\n.collapsible-wrap {\n  width: 100%;\n  .toggleBtn {\n    width: 100%;\n    min-height: 50px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: white;\n    border: none;\n    color: black;\n    font-size: 16px;\n    cursor: pointer;\n    text-align: left;\n    gap: 25px;\n    padding: 0 50px;\n  }\n  .content {\n    width: auto;\n    height: auto;\n    display: none;\n  }\n\n  .show-content {\n    width: auto;\n    height: auto;\n    display: flex;\n    transition: 0.3s ease-in-out;\n  }\n}\n\n.overlay {\n  z-index: 98;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vw;\n  background-color: rgba(0, 0, 0, 0.8);\n  padding: 25px;\n  display: flex;\n  justify-content: center;\n  .overlay-content {\n    max-width: 400px;\n    width: 100%;\n    min-height: 300px;\n    max-height: 80vh;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    &.informational {\n      max-width: 600px;\n      justify-content: initial;\n      border-radius: 15px;\n      .close-overlay {\n        display: flex;\n        width: inherit;\n        justify-content: end;\n        svg {\n          font-size: 35px;\n          color: red;\n          cursor: pointer;\n        }\n      }\n      .body-overlay {\n        display: flex;\n        width: 100%;\n        padding: 25px;\n        flex-direction: column;\n        overflow-y: scroll;\n        position: relative;\n        .caregiver-photo-wrapper {\n          display: flex;\n          justify-content: center;\n          .caregiver-photo {\n            width: 100px;\n            height: 100px;\n            border-radius: 50%;\n            overflow: hidden;\n            margin-top: -120px;\n            border: 5px solid white;\n            img {\n              width: 100%;\n            }\n          }\n        }\n\n        ul {\n          margin: 0;\n          padding: 0 0 0 13px;\n        }\n        h2 {\n          display: flex;\n          gap: 10px;\n          justify-content: space-between;\n          border-bottom: 1px solid $color4;\n          padding-bottom: 15px;\n          margin-bottom: 0;\n        }\n        .row {\n          display: flex;\n          flex-direction: row;\n          gap: 10px;\n          border-bottom: 1px solid $color4;\n          .col:first-child {\n            flex: 0 0 40%;\n            justify-content: left;\n            border-right: 1px solid $color4;\n          }\n          .col {\n            padding: 10px 0;\n            display: flex;\n            justify-content: center;\n            flex-direction: column;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n    .buttons-wrapper {\n      display: flex;\n      gap: 5px;\n    }\n  }\n}\n\n@media (max-width: $md) {\n  .collapsible-wrap {\n    .toggleBtn {\n      padding: 0 10px;\n      font-size: 14px;\n      text-align: left;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
